<template>
  <div class="mx-4">
    <v-card class="d-flex flat dense rounded-0" elevation="0" style="border:0px;background-color: rgb(245, 245, 249);">
      <!-- Page Title -->
      <div class="pa2 pl-3 mr-auto align-self-center" style="color:rgb(86,106,127);font-weight:800;font-size:1.4rem">{{pTitles}}</div>
      <div class="pa2 pr-3">
        <v-breadcrumbs :items="pCrumbs" divider=">" style='color:rgb(86,106,127) !important;'></v-breadcrumbs>
      </div>
    </v-card>
  </div>
</template>

<script> 
  export default {
    name: 'PageCrumbs', 
props: {
      pTitles: String,
      pCrumbs: [], 
    },
    data () {
        return {
         
          items: [],
        } 
    }
    , created() {
     // this.items = pCrumbs;
    }
  }
</script>